/**
 * @fileoverview Login Page Component
 * @description Login page for PingID/PingFederate authentication
 * @module pages/Login
 */

import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
  Container,
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import Spinner from '@/components/common/Spinner/Spinner';
import { useAuth } from '@/context';
import './Login.css';

/**
 * Login Page Component
 * @returns {JSX.Element} Login page
 */
export const Login = () => {
  const { login, isLoading, error } = useAuth();

  const handleLogin = async () => {
    await login();
  };

  return (
    <Container maxWidth="sm" className="login-page">
      <Box className="login-page__container">
        <Card elevation={4} className="login-page__card">
          <CardContent className="login-page__content">
            {/* Logo/Title */}
            <Box className="login-page__header">
              <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                QE Portal
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Quality Engineering Portal
              </Typography>
            </Box>

            {/* Error Alert */}
            {error && (
              <Alert severity="error" className="login-page__error">
                {error}
              </Alert>
            )}

            {/* Login Button */}
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={handleLogin}
              disabled={isLoading}
              startIcon={isLoading ? <Spinner size={20} color="inherit" /> : <LoginIcon />}
              className="login-page__button"
            >
              {isLoading ? 'Signing in...' : 'Sign in with Alaska SSO'}
            </Button>

            {/* Info Text */}
            <Typography
              variant="caption"
              color="text.secondary"
              className="login-page__info"
            >
              You will be redirected to Alaska Airlines SSO for authentication
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;